import { useParams, Link } from 'react-router-dom';
import { categories, getComicsByCategory } from '@/mocks/comics';
import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const categoryComics = getComicsByCategory(slug || 'hanman');

  const categorySchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        name: `布丁漫画 - ${currentCategory.name}分类`,
        description: `布丁漫画${currentCategory.name}下拉式阅读专区，免费看${currentCategory.name}全集漫画，支持在线追更，下拉式阅读不卡顿一气呵成。`,
        url: `https://budingmanhua.com/category/${currentCategory.slug}`,
        isPartOf: { '@id': 'https://budingmanhua.com/#website' },
      },
      {
        '@type': 'ItemList',
        itemListElement: categoryComics.map((comic, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'CreativeWork',
            name: comic.title,
            url: `https://budingmanhua.com/comic/${comic.id}`,
          },
        })),
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={`布丁漫画${currentCategory.name}下拉式免费阅读 | 布丁漫画下拉式全集在线追更`}
        description={`布丁漫画${currentCategory.name}下拉式阅读专区，提供${currentCategory.name}全集免费漫画在线观看，下拉式阅读不卡顿一气呵成，支持追更最新章节。`}
        keywords={`布丁漫画下拉式看,${currentCategory.name},下拉式阅读,免费漫画,全集漫画,在线追更,布丁漫画网`}
        canonicalUrl={`https://budingmanhua.com/category/${currentCategory.slug}`}
        schema={categorySchema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentCategory.name },
            ]}
          />
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-6">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className={`${currentCategory.icon} text-lg`}></i>
            </span>
            <div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {currentCategory.name}
              </h1>
              <p className="text-xs text-foreground-500">共 {categoryComics.length} 部作品</p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-1.5 text-sm rounded-full transition-colors cursor-pointer whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryComics.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
              {categoryComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <span className="w-16 h-16 flex items-center justify-center mx-auto mb-4 text-foreground-300">
                <i className="ri-book-open-line text-4xl"></i>
              </span>
              <p className="text-foreground-500">该分类暂无漫画，敬请期待</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}